import { NgModule } from '@angular/core';
import { ButtonModule } from '@shared/components/button/button.module';
import { InputModule } from '@shared/components/form/input/input.module';
import { SharedModule } from '@shared/shared.module';
import { LoginComponent } from './login.component';

@NgModule({
	declarations: [LoginComponent],
	imports: [SharedModule, ButtonModule, InputModule],
	exports: [LoginComponent],
})
export class LoginModule {}
